<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-wrap">
          <div
            v-if="!newPlaceCategory"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >Actualización de categoría de lugares de interés</div>
          <div
            v-if="newPlaceCategory"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >Nueva categoría de lugares de interés</div>

          <div class="flex flex-col w-full pl-4">
            <form class="w-full max-w-lg" id="placeCategoryForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="name_category"
                  >Categoría *</label>
                  <input
                    :class="{'border-red-500': errors.name_category}"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="name_category"
                    type="text"
                    name="name_category"
                    v-model="placeCategory.nombre_categoria"
                  />
                  <p
                    v-if="errors.name_category"
                    class="text-red-500 text-xs italic"
                  >Ingrese una categoría de lugares de interés.</p>
                </div>
                <div class="w-full px-3 mb-6">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="category_image"
                  >Agregue un ícono *</label>
                  <p
                    v-if="errors.icon_category"
                    class="text-red-500 text-xs italic"
                  >Debe agregar o seleccionar un ícono.</p>
                  <p
                    v-if="errors.icon_extension"
                    class="text-red-500 text-xs italic"
                  >Debe seleccionar un archivo de imagen válido.</p>
                  <p
                    v-if="errors.icon_dimension"
                    class="text-red-500 text-xs italic"
                  >La imagen seleccionada excede el tamaño permitido.</p>
                  <div class="flex items-center">
                    <div class="w-3/12">
                      <div
                        class="relative w-16 h-16 bg-white border-2 border-solid border-gray-200"
                      >
                        <img :src="category_url" class="h-full w-full object-cover" alt />
                        <div
                          class="-mb-4 -mr-4 flex rounded-full h-8 w-8 absolute bottom-0 right-0 items-center justify-center bg-gray-200 hover:bg-gray-400 hover:text-gray-800 cursor-pointer rounded-full border-solid border-4 border-gray-400"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="fill-current text-gray-500 h-4 w-4"
                            viewBox="0 0 24 24"
                          >
                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                            <path d="M0 0h24v24H0z" fill="none" />
                          </svg>
                          <input
                            @change="changeImage"
                            class="cursor-pointer bottom-0 right-0 w-12 h-12 absolute block opacity-0 pin-r pin-t"
                            type="file"
                            name="category_image"
                            accept="image/png, image/jpeg"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col w-9/12 text-left">
                      <span
                        class="text-xs font-bold text-gray-900 tracking-wider"
                      >&#8226;&nbsp;El archivo seleccionado debe ser jpeg, jpg o png.</span>
                      <span
                        class="text-xs font-bold text-gray-900 tracking-wider"
                      >&#8226;&nbsp;La dimensión de la imagen seleccionada debe ser menor o igual a 250 píxeles por 250 píxeles.</span>
                    </div>
                  </div>
                </div>
                <div class="w-full px-3 mb-3">
                  <span
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >O</span>
                </div>
                <div class="w-full px-3 mb-6">
                  <span
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  >Seleccione un ícono</span>
                  <div class="flex flex-wrap items-center justify-center">
                    <template v-for="(icon, index) in icons">
                      <img
                        :class="{'bg-teal-500': selectedIcon === icon.name}"
                        class="w-16 h-16 p-2 cursor-pointer"
                        :src="srcUrl + icon.url"
                        :key="index"
                        @click="selectIcon(icon)"
                      />
                    </template>
                  </div>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveCategory()"
                >Guardar</button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >Cerrar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Categoría guardada exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";

export default {
  name: "place-category-modal",
  data() {
    return {
      aux_placeCategory: null,
      placeCategory: {
        nombre_categoria: null,
        enable: null,
        id: null,
        url_image: null
      },
      errors: {
        name_category: false,
        codeError: "Ha ocurrido un error",
        icon_category: false,
        icon_extension: false,
        icon_dimension: false
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      icons: [],
      selectedIcon: null,
      srcUrl: 'apidev',
      category_url: null
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    newPlaceCategory: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    EventBus.$on("editModal", this.setData);
    this.fetchCategoriesIcons();
    this.category_url = this.srcUrl + "/" + this.placeCategory.url_image;
  },
  components: {
    AlertDialog
  },
  methods: {
    fetchCategoriesIcons() {
      this.axios
        .get("apidev/api/places/categories/icons", this.config)
        .then(response => {
          this.icons = response.data.icons;
        })
        .catch(error => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    selectIcon(icon) {
      this.selectedIcon = icon.name;
    },
    reset: function() {
      this.placeCategory = {
        nombre_categoria: null,
        enable: null,
        id: null,
        url_image: null
      };
      this.errors = {
        name_category: false,
        codeError: "Ha ocurrido un error"
      };
      this.selectedIcon = null;
      this.category_url = this.srcUrl + "/" + this.placeCategory.url_image;
    },

    close() {
      this.reset();
      this.$emit("close");
    },
    changeImage: function(event) {
      const file = event.target.files[0];

      if (this.checkMimeType(file) === "") {
        this.errors.icon_extension = true;
        this.category_url = this.srcUrl + "/null";
      } else {
        let image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = () => {
          if (image.height > 250 && image.width > 250) {
            this.errors.icon_dimension = true;
            this.category_url = this.srcUrl + "/null";
          } else {
            this.errors.icon_extension = false;
            this.errors.icon_dimension = false;
            this.placeCategory.url_image = URL.createObjectURL(file);
            this.category_url = this.placeCategory.url_image;
          }
        };
      }
    },
    setData: function(category) {
      this.placeCategory = Object.assign({}, category);
      this.aux_placeCategory = Object.assign({}, category);
      this.selectedIcon = category.icon;
      this.category_url = this.srcUrl + "/" + this.placeCategory.url_image;
    },

    saveCategory() {
      const form = document.getElementById("placeCategoryForm");
      const signInData = new FormData(form);

      if (this.newPlaceCategory) {
        const validForm = this.checkPlaceCategoryForm(signInData);
        if (validForm) {
          const category_image = signInData.get("category_image");
          const mimeType = this.checkMimeType(category_image);
          const newDate = Date.now();
          const nameFile = "category_image_" + newDate + mimeType;

          if (this.placeCategory.url_image !== null) {
            signInData.set("category_image", category_image, nameFile);
          } else {
            signInData.set("category_image", "");
          }

          signInData.set("name", this.placeCategory.nombre_categoria);
          signInData.set("icon", this.selectedIcon);

          this.axios
            .post(
              "apidev/api/places/categories/",
              signInData,
              this.config
            )
            .then(response => {
              return this.axios.post("apidev/api/binnacles/monitor/save/",{
                "module": "Configuración", 
                "action": "Creación de una categoría de lugar de interés", 
                "observation": this.placeCategory.nombre_categoria,
                "email": localStorage.getItem("email")
                },
                this.config
              )
            })
            .then(() => {
              this.showingSuccess = true;
              this.$emit("updateAllPlaceCategories");
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              if (
                error.response.status == 400 ||
                error.response.status == 401
              ) {
                if (
                  error.response.data.name === "TokenExpiredError" ||
                  error.response.data.name === "InvalidTokenError" ||
                  error.response.data.name === "JsonWebTokenError"
                ) {
                  this.$router.push({ path: "/login" });
                }
              }
              if (error.response.status == 409) {
                this.errors.codeError =
                  "Ya hay otra categoría con ese nombre. Pruebe con otro nombre";
              }
              this.showingError = true;
            });
        }
      } else {
        const validForm = this.checkFormUpdatePlaceCategory(signInData);
        if (validForm) {
          const category_image = signInData.get("category_image");
          const mimeType = this.checkMimeType(category_image);
          const newDate = Date.now();
          const nameFile = "category_image_" + newDate + mimeType;

          if (this.placeCategory.url_image !== null) {
            signInData.set("category_image", category_image, nameFile);
          } else {
            signInData.set("category_image", "");
          }

          signInData.set("name", this.placeCategory.nombre_categoria);
          signInData.set("icon", this.selectedIcon);
          signInData.set("enabled", this.placeCategory.enabled);

          this.axios
            .put(
              "apidev/api/places/categories/" + this.placeCategory.id,
              signInData,
              this.config
            )
            .then(response => {
              let observation = ""
              if(this.placeCategory.nombre_categoria != this.aux_placeCategory.nombre_categoria){
                observation = `${this.aux_placeCategory.nombre_categoria} / ${this.placeCategory.nombre_categoria}`
              } else {
                observation = `${this.placeCategory.nombre_categoria}`
              }
              
              return this.axios.post("apidev/api/binnacles/monitor/save/",{
                "module": "Configuración", 
                "action": "Edición de una categoría de lugar de interés", 
                "observation": observation,
                "email": localStorage.getItem("email")
                },
                this.config
              )
            })
            .then(() => {
              this.showingSuccess = true;
              this.$emit("updatePlaceCategoryModal");
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              if (
                error.response.status == 400 ||
                error.response.status == 401
              ) {
                if (
                  error.response.data.name === "TokenExpiredError" ||
                  error.response.data.name === "InvalidTokenError" ||
                  error.response.data.name === "JsonWebTokenError"
                ) {
                  this.$router.push({ path: "/login" });
                }
              }
              this.showingError = true;
            });
        }
      }
    },

    checkPlaceCategoryForm: function(signInData) {
      if (signInData.get("name_category") === "") {
        this.errors.name_category = true;
      } else {
        this.errors.name_category = false;
      }

      if (
        this.category_url === this.srcUrl + "/null" &&
        this.selectedIcon === null
      ) {
        this.errors.icon_category = true;
        this.errors.icon_extension = false;
        this.errors.icon_dimension = false;
      } else {
        this.errors.icon_category = false;
      }

      if (this.errors.name_category || this.errors.icon_category) {
        return false;
      }

      return true;
    },

    checkFormUpdatePlaceCategory: function(signInData) {
      if (signInData.get("name_category") === "") {
        this.errors.name_category = true;
      } else {
        this.errors.name_category = false;
      }

      if (
        this.category_url === this.srcUrl + "/null" &&
        this.selectedIcon === null
      ) {
        this.errors.icon_category = true;
        this.errors.icon_extension = false;
        this.errors.icon_dimension = false;
      } else {
        this.errors.icon_category = false;
      }

      if (this.errors.name_category || this.errors.icon_category) {
        return false;
      }

      return true;
    },
    checkMimeType(file) {
      let mimeType = "";
      switch (file.type) {
        case "image/jpeg":
          mimeType = ".jpeg";
          break;
        case "image/png":
          mimeType = ".png";
          break;
        case "image/jpg":
          mimeType = ".jpg";
          break;
        default:
          mimeType = "";
          break;
      }
      return mimeType;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
